import React, { ButtonHTMLAttributes } from "react";
import styled from "@emotion/styled";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { HalfCircleLeftIcon, HalfCircleRightIcon } from "../icons";
import { theme } from "@/theme";
export interface DotButtonProps {
  selected: boolean;
  onClick: () => void;
}

export interface ArrowButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: "white" | "blue";
  shape?: "circle" | "none" | "half-circle";
  direction: "left" | "right";
}

const CarouselArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  outline: 0;
  background-color: transparent;
  touch-action: manipulation;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  border: 0;
  fill: #ffffff;
  padding: 0;
  transition: all ease-in-out 250ms;
  z-index: 1;

  &:hover {
    cursor: pointer;
  }

  &.next {
    left: auto;
    right: 0px;
  }

  &.round {
    background-color: hsl(var(--color-primary));
    border-radius: 50%;

    @media (hover: hover) {
      //needed to fix "sticky" hover state for mobile
      &:hover {
        background-color: hsl(var(--color-primary-50));
      }
    }
  }
`;

export const ArrowButton = ({
  shape,
  color,
  direction,
  ...rest
}: ArrowButtonProps) => {
  const isRound = shape === "circle";
  const isHalfCircle = shape === "half-circle";
  const isNextButton = direction === "right";
  const iconColor = color === "blue" ? theme.palette.primary.main : "white";
  const iconStyle = {
    fontSize: isRound ? 36 : 40,
    color: iconColor,
    filter:
      iconColor === "white"
        ? "drop-shadow(0px 1px .5px hsl(var(--color-gray-900) / .25))"
        : "",
  };

  return (
    <CarouselArrowButton
      className={`${isRound ? "round" : ""} ${
        isNextButton ? "next" : ""
      } focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75`}
      {...rest}
    >
      {isHalfCircle ? (
        !isNextButton ? (
          <HalfCircleLeftIcon />
        ) : (
          <HalfCircleRightIcon />
        )
      ) : !isNextButton ? (
        <ChevronLeftIcon style={iconStyle} />
      ) : (
        <ChevronRightIcon style={iconStyle} />
      )}
    </CarouselArrowButton>
  );
};
